<template>
  <div id="CustomerScopeRateReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Customer Rental Scope Rates</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'customerScopeRateReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'customerScopeRateReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Customer Scope Rate Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "CustomerScopeRateReport",
  metaInfo() {
            return {title: "Customer Rental Scope Rates Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Customer Number',
                field: 'contact_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input

                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Name',
                field: 'contact',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Class',
                field: 'customer_class',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Class", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Contract',
                field: 'contract',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Contract", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input

                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Section',
                field: 'section',
                hidden:false,
                fpFieldType:"option",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Section", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Equipment Type',
                field: 'truck_type',
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Equipment Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Rate Column',
                field: 'type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rate Column", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Rate',
                field: 'rate',
                fpFieldType:"integer",
                type: 'number',
                hidden:false,
                html: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Rate", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
              label: "Effective Date",
              field: "effective_date",
              filterable: true,
              fpFieldType:"custom_date",
              hidden:false,
              filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "MM/DD/YYYY", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input

                trigger: "enter" //only trigger on enter not on keyup
              }
            },
            {
              label: "Expiry Date",
              field: "expiry_date",
              filterable: true,
              fpFieldType:"custom_date",
              hidden:false,
              filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "MM/DD/YYYY", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input

                trigger: "enter" //only trigger on enter not on keyup
              }
            },
            {
                label: 'Credit Mgr',
                field: 'credit_mgr',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Credit Mgr", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input

                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Salesrep Num',
                field: 'salesrep_num',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Salesrep Num", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input

                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                  label: 'Active',
                  field: 'status',
                  hidden:false,
                  fpFieldType:"option",
                  filterable: true,
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "All", // placeholder for filter input
                      filterDropdownItems: ['Y','N'],
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                  },
             },

        ],
        batchProcess:0,
        batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'customer_rental_scope_rate_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/customer-rental-scoperate-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
             if ( self.action == "export" ||  self.action == "export_queue") {
                  if ( data.code == "201" ) {
                      alert(data.message);
                  } else {
                      if ( self.action == "export" ) {
                          self.excel = data.content.web;
                          var save = document.createElement("a");
                          save.href = self.excel;
                          save.download = data.content.web;
                          save.target = "_blank";

                          document.body.appendChild(save);
                          save.click();
                          document.body.removeChild(save);

                      } else {

                          self.batchProcess = 1;
                          self.batchNum = data.content;
                      }
                  }
                  self.action = "list";
                  self.loadList();

            } else {
              if (data.content.row != undefined) {
                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'customer-rental-scoperate-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/CustomerRentalScopeRateReport.vue